import { Fragment } from "react";

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";

import SoftBox from "softcomponents/SoftBox";
import SoftTypography from "softcomponents/SoftTypography";
import { BASE_URL } from "settings";

import { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    setTimeout(() => {
      document.title = "นโยบายคุ้มครองข้อมูลส่วนบุคคล | หารือ.คอม";
    }, 100);
  }, []);

  return (
    <Fragment>
      <SoftBox component="section" pt={3} pb={0}>
        <Container>
          <Card>
            <SoftBox
              variant="gradient"
              bgColor="primary"
              borderRadius="xl"
              coloredShadow="dark"
              p={3}
              mt={-3}
              mx={2}
            >
              <SoftBox pt={3}>
                <SoftTypography variant="h4" fontWeight="bold" color="white">
                  {"นโยบายคุ้มครองข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="caption" color="white" opacity={0.8}>
                  {"แก้ไขล่าสุด"}:{" "}
                  {new Date(Date.parse("18 Feb 2023")).toLocaleDateString()}
                </SoftTypography>
              </SoftBox>
            </SoftBox>

            <SoftBox pb={6} px={6}>
              <SoftTypography variant="body2" color="text" mt={6}>
                {
                  "คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ จัดทำขึ้นเพื่อชี้แจงรายละเอียดและวิธีการจัดการและประมวลผลข้อมูลส่วนบุคคลที่หารือ.คอม (“เรา”) ได้รับมาจากท่าน วัตถุประสงค์ในการเก็บรวบรวม ใช้ เปิดเผย และประมวลผล ตลอดจนระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคลดังกล่าวและสิทธิของท่านในฐานะเจ้าของข้อมูลส่วนบุคคล ทั้งนี้ เนื่องจากเราประกอบกิจการในประเทศไทย การประมวลผลข้อมูลส่วนบุคคลของท่านจึงอยู่ภายใต้บังคับและต้องปฏิบัติให้สอดคล้องกับกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"วิธีเก็บรวบรวมและรับข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "1. หารือ.คอม เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่านผ่านช่องทางต่าง ๆ ดังนี้"
                }
                :
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับ หารือ.คอม โดยตรง: ท่านอาจให้ข้อมูลส่วนบุคคลแก่ หารือ.คอม โดยตรง กรณีนี้มักเกิดขึ้นเมื่อท่านติดต่อกับ หารือ.คอม เพื่อสอบถาม กรอกแบบฟอร์มต่าง ๆ โดยทางออนไลน์หรือโดยเอกสาร เพื่อสมัครใช้บริการหรือร่วมกิจกรรม สอบถามข้อมูล รับการติดต่อสื่อสารทางการตลาด หรือให้ความเห็น/คำติชมแก่ หารือ.คอม เป็นต้น"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) ข้อมูลส่วนบุคคลที่ หารือ.คอม เก็บรวบรวมจากท่านโดยอัตโนมัติ: หารือ.คอม อาจเก็บรวบรวมข้อมูลทางเทคนิคบางอย่างเกี่ยวกับอุปกรณ์ กิจกรรมและรูปแบบการเข้าชม ข้อมูลประวัติการใช้งานเว็บไซต์ (Browsing) ของท่านโดยอัตโนมัติโดยใช้คุกกี้ (Cookies) และเทคโนโลยีอื่น ๆ ที่คล้ายคลึงกัน รายละเอียดเพิ่มเติมโปรดดู"
                  }
                  <SoftTypography
                    variant="body2"
                    color="text"
                    component="a"
                    href={`${BASE_URL}/privacy/cookies`}
                    target="_blank"
                    rel="noreferrer"
                    sx={{
                      "&:hover": {
                        color: ({ palette: { info } }) => info.main,
                      },
                    }}
                  >
                    {"นโยบายคุกกี้"}
                  </SoftTypography>
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) ข้อมูลส่วนบุคคลที่ หารือ.คอม ได้รับมาจากบุคคลภายนอก: หารือ.คอม อาจได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลภายนอกเป็นครั้งคราว เช่น ธนาคาร หน่วยงานของรัฐ"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "2. ในการเก็บรวบรวมข้อมูลส่วนบุคคลของท่าน ท่านจะได้รับการแจ้งถึงรายละเอียดต่าง ๆ ตามที่ระบุในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ หรือหากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้ต้องได้รับความยินยอมจากท่าน หารือ.คอม จะขอความยินยอมโดยชัดแจ้งจากท่านเพื่อให้ หารือ.คอม สามารถประมวลผลข้อมูลส่วนบุคคลของท่านได้"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"ข้อมูลส่วนบุคคลที่ถูกเก็บรวบรวม"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "1. ข้อมูลส่วนบุคคลที่ หารือ.คอม เก็บรวมรวบภายใต้คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ เป็นข้อมูลส่วนบุคคลของเจ้าของข้อมูลส่วนบุคคลในประเภทดังต่อไปนี้"
                }
                :
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) ลูกค้า ได้แก่ ผู้เข้าชมเว็บไซต์ ผู้รับบริการ ผู้เข้าร่วมกิจกรรม และบุคคลอื่นใดซึ่งติดต่อเพื่อขอข้อมูลหรือขอรับบริการจากหารือ.คอม ทั้งนี้ ไม่ว่าจะเป็นการได้มาซึ่งข้อมูลส่วนบุคคลโดยทางตรงหรือทางอ้อม"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) คู่สัญญา ผู้ประกอบวิชาชีพ และผู้ที่เกี่ยวข้องกับการดำเนินธุรกิจของ หารือ.คอม ได้แก่ บุคคลธรรมดาที่เป็นคู่สัญญาหรือมีความเกี่ยวข้องตามสัญญาใด ๆ กับ หารือ.คอม ซึ่งหมายความรวมถึงคู่ค้า ผู้ขาย ผู้จัดหา ผู้ให้บริการ ผู้รับทำงาน ที่ปรึกษา และบุคคลอื่น ๆ ในลักษณะคล้ายคลึงกัน"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) บุคลากรของ หารือ.คอม ได้แก่ บุคคลธรรมดาที่เป็นพนักงาน ลูกจ้าง หรือบุคคลใดที่ทำงานให้แก่ หารือ.คอม กรรมการ ผู้จัดการ ผู้บริหาร ผู้เชี่ยวชาญและบุคคลที่ได้รับเงินเดือน ค่าจ้าง สวัสดิการ หรือผลตอบแทนอื่นใดโดยตรงจาก หารือ.คอม และหมายความรวมถึงบุคคลในครอบครัวของบุคลากรของ หารือ.คอม"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ง) ผู้สมัคร ได้แก่ บุคคลธรรมดาที่ได้ยื่นใบสมัครหรือรายละเอียดเกี่ยวกับประวัติส่วนตัวมาที่ หารือ.คอม ทั้งที่เป็นลายลักษณ์อักษรหรือวาจา โดยมีวัตถุประสงค์เพื่อสมัครงาน/สมัครฝึกงาน/สมัครทุน เป็นพนักงานหรือลูกจ้าง/ผู้ฝึกงาน/ผู้ขอรับทุนของหารือ.คอม ซึ่งยังไม่ได้รับคัดเลือกจาก หารือ.คอม และหมายความรวมถึงบุคคลในครอบครัวผู้สมัคร และบุคคลอ้างอิง"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "2. ข้อมูลส่วนบุคคลของท่านที่ถูกเก็บรวบรวมและอยู่ภายใต้คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ ไม่ว่าจะเป็นข้อมูลส่วนบุคคลที่ท่านให้ไว้กับ หารือ.คอม โดยตรง หรือข้อมูลส่วนบุคคลที่ หารือ.คอม เก็บรวบรวมจากท่านโดยอัตโนมัติ หรือข้อมูลส่วนบุคคลที่ หารือ.คอม ได้รับมาจากบุคคลภายนอก เช่น"
                }
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) ข้อมูลส่วนตัว เช่น ชื่อนามสกุล วัน/เดือน/ปีเกิด อายุ เพศ รูปถ่าย หมายเลขและสำเนาหนังสือเดินทาง (Passport) หรือบัตรประจำตัวประชาชน ลายมือชื่อ สัญชาติ สถานภาพสมรส และข้อมูลบุคคลในครอบครัว"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) ข้อมูลส่วนบุคคลที่มีความอ่อนไหว เช่น ศาสนา ประวัติอาชญากรรม ข้อมูลสุขภาพ ผลการตรวจสุขภาพ ความพิการ และข้อมูลชีวภาพ"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) ข้อมูลการติดต่อ เช่น ที่อยู่อาศัย หมายเลขโทรศัพท์ อีเมล ข้อมูลการติดต่อทางโซเชียลมีเดีย และรายละเอียดบุคคลที่ติดต่อได้ในกรณีฉุกเฉิน"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ง) ข้อมูลเกี่ยวกับการเงิน เช่น หมายเลขบัญชีธนาคาร และข้อมูลเกี่ยวกับภาษีอากรต่าง ๆ"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(จ) ข้อมูลเกี่ยวกับการใช้งานระบบต่างๆ ของ หารือ.คอม เช่น ข้อมูลลงทะเบียนสมัครใช้บริการระบบของ หารือ.คอม ชื่อบัญชีผู้ใช้งาน (Account) ข้อมูลบัญชีผู้ใช้งาน รหัสประจำตัว (Username) รหัสผ่าน (Password) และรหัสลับ (PIN) (ถ้ามี) ข้อมูลที่แสดงบนหน้าประวัติผู้ใช้งานและหน้าการสมัครบริการต่าง ๆ ข้อมูลที่ท่านได้แก้ไข ปรับปรุงในข้อมูลบัญชีผู้ใช้งาน (Account) ของท่าน ข้อมูลที่ได้จากบัญชีผู้ใช้งาน (Account) อื่น ๆ ที่ หารือ.คอม มีเหตุอันควรเชื่อได้ว่าท่านควบคุมดูแลอยู่ ข้อมูลการใช้บริการ ความสนใจและความเห็นทุกอย่างที่ท่านได้แสดงผ่านระบบของ หารือ.คอม (ถ้ามี) ข้อมูลการร่วมกิจกรรมต่าง ๆ ของท่านในระบบของ หารือ.คอม ข้อมูลการทำแบบสอบถาม ข้อมูลที่ได้จากการที่ท่านติดต่อกับ หารือ.คอม หรือทีมงานของ หารือ.คอม"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ฉ) ข้อมูลด้านเทคนิค เช่น ข้อมูลการเข้าใช้งานเว็บไซต์และระบบต่าง ๆ ของ หารือ.คอม ข้อมูลจราจรทางคอมพิวเตอร์ (Log) ข้อมูลการติดต่อและสื่อสารระหว่างท่านและผู้ใช้งานรายอื่น ข้อมูลจากการบันทึกการใช้งาน เช่น ตัวระบุอุปกรณ์ หมายเลข IP ของคอมพิวเตอร์ รหัสประจำตัวอุปกรณ์ ประเภทอุปกรณ์ ข้อมูลเครือข่ายมือถือ ข้อมูลการเชื่อมต่อ ข้อมูลตำแหน่งที่ตั้งทางภูมิศาสตร์ ประเภทของเบราว์เซอร์ (Browser) ข้อมูลบันทึกการเข้าออกระบบ ข้อมูลแอปพลิเคชันหรือเว็บไซต์ที่ท่านเข้าถึงก่อนและหลัง (Referring Website) ข้อมูลบันทึกประวัติการใช้ระบบ ข้อมูลบันทึกการเข้าสู่ระบบ (Login Log) ข้อมูลรายการการทำธุรกรรม (Transaction Log) พฤติกรรมการใช้งาน (Customer Behavior) สถิติการเข้าระบบ เวลาที่เยี่ยมชมระบบ (Access Time) ข้อมูลที่ท่านค้นหา การใช้ฟังก์ชันต่าง ๆ ในระบบ และข้อมูลที่ หารือ.คอม ได้เก็บรวบรวมผ่านคุกกี้ (Cookies) หรือเทคโนโลยีอื่นที่คล้ายกัน"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ช) ข้อมูลเกี่ยวกับการศึกษา การฝึกอบรม และการทำงาน เช่น ประวัติการศึกษาและการฝึกอบรม หนังสือรับรองคุณวุฒิหรือใบแสดงผลการศึกษา ผลคะแนนหรือระดับคะแนน ระดับการศึกษา ความสามารถทางภาษา ข้อมูลใบอนุญาตในการประกอบวิชาชีพ เลขที่ทะเบียน วันที่เริ่มอายุทะเบียน วันที่หมดอายุทะเบียน การต่ออายุทะเบียน ข้อมูลการปฏิบัติหน้าที่ วันที่เริ่มงาน ข้อมูลการอบรมและข้อมูลการทดสอบซึ่งจัดโดย หารือ.คอม หรือหน่วยงานอื่นที่เกี่ยวข้อง วุฒิบัตรหรือประกาศนียบัตร ประวัติการทำงาน เงินเดือนหรือค่าจ้าง"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ซ) ข้อมูลอื่นๆ เช่น บันทึกเสียงการสนทนา และไฟล์ข้อมูลที่อัปโหลดในระบบของคุณ"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"การใช้ข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "1. หารือ.คอม ใช้ข้อมูลที่เก็บรวบรวมจากผู้ใช้ หรือข้อมูลที่เกี่ยวกับตัวผู้ใช้เพื่อให้ผู้ใช้ได้ใช้บริการของ หารือ.คอม ได้ตรงตามวัตถุประสงค์ของผู้ใช้ และเพื่อการอื่นที่จำเป็นภายใต้กฎหมาย ดังต่อไปนี้"
                }
                :
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) เพื่อให้บริการ หรือปฏิบัติหน้าที่ตามสัญญาที่มีต่อผู้ใช้"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) เพื่อตอบสนองคำร้องขอของผู้ใช้ สื่อสารกับผู้ใช้ ดำเนินการให้บริการลูกค้า และให้ความช่วยเหลือทางเทคนิค"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) เพื่อยืนยันตัวตนของผู้ใช้ และป้องการสแปม หรือการกระทำที่ไม่ได้รับอนุญาต หรือผิดกฎหมาย"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ง) เพื่อป้องกัน ตรวจจับ หลีกเลี่ยง และตรวจสอบการฉ้อโกง การละเมิดความปลอดภัย หรือการกระทำอื่น ๆ ที่อาจเป็นการกระทำที่ต้องห้าม หรือผิดกฎหมาย"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(จ) เพื่อดำเนินการตามที่จำเป็นเพื่อปฏิบัติตามหน้าที่ที่บริษัทมีต่อหน่วยงานที่มีอำนาจควบคุม หน่วยงานด้านภาษี การบังคับใช้กฎหมาย หรือภาระผูกพันตามกฎหมายของบริษัท"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ฉ) เพื่อดำเนินการตามที่จำเป็นเพื่อประโยชน์ที่ชอบด้วยกฎหมายของบริษัท หรือของบุคคลอื่น หรือของนิติบุคคลอื่น"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ช) เพื่อป้องกัน หรือหยุดยั้งอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคลหนึ่งบุคคลใด"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ซ) เพื่อดำเนินการตามที่จำเป็นในการทำหน้าที่เพื่อสาธารณประโยชน์ให้สำเร็จลุล่วง หรือเป็นการจำเป็นเพื่อใช้อำนาจทางกฎหมายที่บริษัทได้รับสิทธิในการดำเนินการ"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ฌ) เพื่อให้บรรลุตามวัตถุประสงค์เกี่ยวกับการเตรียมเอกสารทางประวัติศาสตร์เพื่อสาธารณประโยชน์ หรือเพื่อวัตถุประสงค์เกี่ยวกับการค้นคว้า หรือสถิติโดยมีมาตรการรักษาความปลอดภัยที่เพียงพอเหมาะสม"
                  }
                </SoftTypography>
              </SoftBox>

              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "2. บริษัทใช้ข้อมูลที่เก็บรวบรวมจากผู้ใช้ หรือข้อมูลที่เกี่ยวกับตัวผู้ใช้เพื่อให้ผู้ใช้ได้รับประโยชน์จากการใช้บริการ ตามที่ผู้ใช้เลือกให้ความยินยอม ดังต่อไปนี้"
                }
                :
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) เพื่อปรับปรุงบริการฯ ของบริษัท และตอบสนองต่อความต้องการ และความพึงพอใจของผู้ใช้ รวมถึงเพื่อวัตถุประสงค์ที่เกี่ยวกับการค้นคว้า และการวิเคราะห์อื่นๆ โดยการศึกษาและทำความเข้าใจการเข้าถึงบริการและใช้บริการฯ ของบริษัท"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) เพื่อเสนอและให้สินค้า บริการ ส่วนลด หรือโปรโมชั่นจากบริษัท และ/หรือบริษัทในเครือ และคู่ค้าของบริษัท"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) เพื่อวิเคราะห์ ทำการตลาด และทำการโฆษณาตามกลุ่มเป้าหมาย รวมถึงปรับปรุงการให้บริการและข้อเสนอส่งเสริมการขายให้ทันสมัยยิ่งขึ้น"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "หากผู้ใช้ไม่ให้ข้อมูลของผู้ใช้กับบริษัท หรือให้ข้อมูลที่ไม่ถูกต้อง ครบถ้วน บริษัทอาจไม่สามารถอำนวยความสะดวก ติดต่อสื่อสาร หรือให้บริการของบริษัทบางส่วน หรือทั้งหมดแก่ผู้ใช้ได้"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"การเปิดเผยข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "1. หารือ.คอม อาจเปิดเผยข้อมูลส่วนบุคคลของท่าน ภายใต้วัตถุประสงค์ที่กำหนดและตามหลักเกณฑ์ที่กฎหมายกำหนด ให้แก่หน่วยงานและบุคคลดังต่อไปนี้"
                }
                :
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ก) หารือ.คอม และให้หมายความรวมถึงพนักงาน ลูกจ้าง กรรมการ ผู้จัดการ หรือบุคลากรของ หารือ.คอม เท่าที่เกี่ยวข้อง และตามจำเป็น (need-to-know basis) เพื่อการประมวลผลข้อมูลส่วนบุคคลของท่าน"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ข) หน่วยงานที่ร้องขอให้เปิดเผยข้อมูลโดยอาศัยอำนาจตามกฎหมาย เช่น การร้องขอข้อมูลเพื่อการฟ้องร้องหรือดำเนินคดีตามกฎหมาย หรือที่มีความเกี่ยวข้องกับกระบวนการทางกฎหมาย เช่น สำนักงานป้องกันและปราบปรามการฟอกเงิน สำนักงานคณะกรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ สำนักงานตำรวจแห่งชาติ กรมสอบสวนคดีพิเศษ สำนักงานอัยการสูงสุด และศาล"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "(ค) พันธมิตร คู่ค้าทางธุรกิจ ผู้ให้บริการ ผู้รับบริการ และผู้ประมวลผลข้อมูลส่วนบุคคลที่ หารือ.คอม มอบหมายให้ทำหน้าที่ดูแลรับผิดชอบ ให้บริการ หรือบริหารจัดการเกี่ยวกับข้อมูลส่วนบุคคล เช่น ด้านการพัฒนาปรับปรุง หรือดูแลรักษามาตรฐานความมั่นคงปลอดภัยของระบบงานและระบบเทคโนโลยีสารสนเทศ ด้านระบบการชำระเงิน การตรวจสอบทางบัญชี การบริหารจัดการทรัพยากรบุคคล หรือการให้บริการอื่นใดอันอาจเป็นประโยชน์ต่อท่าน"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "2. การเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น จะดำเนินการภายใต้วัตถุประสงค์ที่กำหนด หรือวัตถุประสงค์อื่นที่กฎหมายกำหนดให้กระทำได้เท่านั้น ในกรณีที่กฎหมายกำหนดว่าต้องได้รับความยินยอมจากท่าน หารือ.คอม จะขอความยินยอมโดยชัดแจ้งจากท่านก่อน"
                }
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "3. ในกรณีที่ หารือ.คอม เปิดเผยข้อมูลส่วนบุคคลของท่านให้กับบุคคลอื่น หารือ.คอม จะจัดให้มีมาตรการที่เหมาะสมเพื่อคุ้มครองข้อมูลส่วนบุคคลที่ได้เปิดเผยและเพื่อปฏิบัติตามมาตรฐานและหน้าที่การคุ้มครองข้อมูลส่วนบุคคล ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด"
                }
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "4. ในกรณีที่ หารือ.คอม ส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปต่างประเทศ หารือ.คอม จะดำเนินการเพื่อทำให้แน่ใจว่า หารือ.คอม ได้ส่งหรือโอนไปยังประเทศปลายทาง องค์กรระหว่างประเทศ หรือผู้รับข้อมูลในต่างประเทศที่มีมาตรฐานในการคุ้มครองข้อมูลส่วนบุคคลที่เพียงพอ ในบางกรณี หารือ.คอม อาจขอความยินยอมของท่านสำหรับการถ่ายโอนข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ ทั้งนี้ ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด"
                }
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "5. เนื่องจาก หารือ.คอม อาจจำเป็นจะต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่หน่วยงานที่มีอำนาจกำกับดูแล เช่น สำนักงานป้องกันและปราบปรามการฟอกเงิน หากท่านประสงค์ที่จะทราบรายละเอียดการประมวลผลข้อมูลส่วนบุคคลของท่านโดยหน่วยงานที่มีอำนาจกำกับดูแลดังกล่าว สามารถศึกษาเพิ่มเติมได้จากคำประกาศเกี่ยวกับความเป็นส่วนตัว (Privacy Policy) ของหน่วยงานที่มีอำนาจกำกับดูแลนั้น ๆ"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"ระยะเวลาเก็บรักษาข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "1. หารือ.คอม จะเก็บรักษาข้อมูลส่วนบุคคลของท่านตามระยะเวลาที่จำเป็นเพื่อบรรลุวัตถุประสงค์ที่กำหนดในการประมวลผลข้อมูลส่วนบุคคลนั้น ๆ โดยระยะเวลาเก็บรักษาข้อมูลส่วนบุคคลจะเปลี่ยนแปลงไปโดยขึ้นอยู่กับวัตถุประสงค์ที่กำหนดในการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลนั้น ๆ"
                }
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "2. หารือ.คอม จะเก็บรักษาข้อมูลส่วนบุคคลเป็นระยะเวลาตามที่กฎหมายที่เกี่ยวข้องกำหนดและโดยคำนึงถึงแนวปฏิบัติทางธุรกิจสำหรับแต่ละประเภทของข้อมูลส่วนบุคคล หลังจากระยะเวลาดังกล่าว หารือ.คอม อาจทำลายข้อมูลส่วนบุคคลเช่นว่านั้นจากการจัดเก็บหรือระบบของ หารือ.คอม โดยไม่มีการแจ้งให้ท่านทราบล่วงหน้า"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"สิทธิของเจ้าของข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "ในฐานะเจ้าของข้อมูลส่วนบุคคล ท่านมีสิทธิต่าง ๆ ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่านดังต่อไปนี้ ภายใต้หลักเกณฑ์ วิธีการ และเงื่อนไขตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด ทั้งนี้ หากท่านประสงค์ที่จะขอใช้สิทธิของท่าน ท่านสามารถติดต่อโดยตรงมาที่ หารือ.คอม ตามรายละเอียดการติดต่อด้านล่าง"
                }
              </SoftTypography>
              <SoftBox pl={"4rem"}>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"1. สิทธิในการเข้าถึงข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านมีสิทธิในการเข้าถึงข้อมูลส่วนบุคคลของท่านและขอให้ หารือ.คอม ทำสำเนาข้อมูลส่วนบุคคลดังกล่าวให้แก่ท่าน รวมถึงขอให้ หารือ.คอม เปิดเผยการได้มาซึ่งข้อมูลส่วนบุคคลของท่านที่ หารือ.คอม ได้เก็บรวบรวม ใช้ และเปิดเผยโดยไม่จำเป็นต้องขอความยินยอมจากท่าน เท่าที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลอนุญาตให้กระทำได้"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"2. สิทธิในการโอนย้ายข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านมีสิทธิที่จะขอรับข้อมูลส่วนบุคคลเกี่ยวกับท่านในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือหรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติ รวมถึงมีสิทธิขอให้ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวของท่านไปยังผู้ควบคุมข้อมูลส่วนบุคคลรายอื่น หรือตัวท่านเอง เว้นแต่โดยสภาพทางเทคนิคไม่สามารถทำได้ ทั้งนี้ ตามที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนด"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"3. สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านมีสิทธิขอคัดค้านการประมวลผลข้อมูลส่วนบุคคลของท่าน และ หารือ.คอม จะดำเนินการดังกล่าว หาก หารือ.คอม"
                  }
                </SoftTypography>
                <SoftBox pl={"4rem"}>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ก) อาศัยฐานประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลภายนอก หรือเพื่อประโยชน์สาธารณะ ในการประมวลผลข้อมูลส่วนบุคคลของท่าน เว้นแต่ในกรณีที่ หารือ.คอม สามารถแสดงให้เห็นถึงเหตุอันชอบด้วยกฎหมายที่สำคัญยิ่งกว่า หรือการประมวลผลข้อมูลส่วนบุคคลของท่านเป็นไปเพื่อก่อตั้งสิทธิเรียกร้อง การปฏิบัติตามหรือการใช้สิทธิเรียกร้อง หรือการยกข้อต่อสู้ตามกฎหมาย หรือ"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ข) ประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ของการตลาดแบบตรง"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ค) ประมวลผลข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์เกี่ยวกับการศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ เว้นแต่เป็นการจำเป็นเพื่อการดำเนินภารกิจเพื่อประโยชน์สาธารณะของ หารือ.คอม"
                    }
                  </SoftTypography>
                </SoftBox>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ในกรณีที่ท่านคัดค้านการประมวลผล โปรดระบุว่าท่านประสงค์ให้ลบข้อมูลส่วนบุคคลของท่าน หรือระงับไม่ให้ หารือ.คอม ประมวลผลข้อมูลส่วนบุคคลดังกล่าว"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"4. สิทธิในการลบข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านอาจขอให้ หารือ.คอม ลบหรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลได้ในกรณีดังต่อไปนี้"
                  }
                </SoftTypography>
                <SoftBox pl={"4rem"}>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ก) ข้อมูลส่วนบุคคลของท่านหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ที่กำหนดในการประมวลผลข้อมูลส่วนบุคคลของท่าน"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ข) ท่านถอนความยินยอมที่เป็นฐานในการเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคล และ หารือ.คอม ไม่มีอำนาจตามกฎหมายในการเก็บรวบรวมหรือประมวลผลข้อมูลส่วนบุคคลดังกล่าวอีกต่อไป"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {"(ค) ท่านได้คัดค้านการประมวลผลตามข้อ 3 หรือ"}
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ง) เมื่อมีการเก็บหรือประมวลผลข้อมูลส่วนบุคคลของท่านโดยไม่ชอบด้วยกฎหมาย"
                    }
                  </SoftTypography>
                </SoftBox>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "กรณีที่ระบุไว้ข้างต้นนี้จะไม่นำมาใช้บังคับกับการประมวลผลข้อมูลส่วนบุคคลที่มีความจำเป็นเพื่อวัตถุประสงค์ในการใช้เสรีภาพในการแสดงความคิดเห็น เพื่อจัดทำเอกสารประวัติศาสตร์หรือสถิติ เพื่อการปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะ เพื่อการจำเป็นในการปฏิบัติตามกฎหมายเพื่อให้บรรลุวัตถุประสงค์เกี่ยวกับเวชศาสตร์ป้องกันหรืออาชีวเวชศาสตร์ หรือประโยชน์สาธารณะด้านการสาธารณสุข เพื่อวัตถุประสงค์ในการก่อตั้ง ปฏิบัติตาม หรือใช้สิทธิเรียกร้องตามกฎหมาย หรือยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย หรือเพื่อการปฏิบัติตามกฎหมาย"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"5. สิทธิในการระงับการใช้ข้อมูลส่วนบุคคล"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านมีสิทธิขอให้ระงับการประมวลผลข้อมูลส่วนบุคคลของท่านในกรณีดังต่อไปนี้"
                  }
                </SoftTypography>
                <SoftBox pl={"4rem"}>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ก) หารือ.คอม อยู่ระหว่างการตรวจสอบความถูกต้องของข้อมูลส่วนบุคคลตามที่ท่านร้องขอ"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ข) กรณีข้อมูลส่วนบุคคลที่ต้องลบหรือทำลายตามข้อ 4 แต่ท่านประสงค์ให้ระงับการใช้แทน"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ค) หารือ.คอม ไม่มีความจำเป็นต้องใช้ข้อมูลส่วนบุคคลของท่านอีกต่อไป แต่ท่านมีความจำเป็นและขอให้ หารือ.คอม เก็บรักษาข้อมูลส่วนบุคคลดังกล่าวเพื่อใช้ในการก่อตั้งสิทธิเรียกร้อง การปฏิบัติตามหรือการใช้สิทธิเรียกร้อง หรือยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย หรือ"
                    }
                  </SoftTypography>
                  <SoftTypography variant="body2" color="text" mb={1}>
                    {
                      "(ง) หารือ.คอม อยู่ในระหว่างการพิสูจน์ตามข้อ 3 (ก) หรือตรวจสอบตามข้อ 3 (ค) เพื่อปฏิเสธการคัดค้านของท่าน"
                    }
                  </SoftTypography>
                </SoftBox>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"6. สิทธิในการแก้ไขข้อมูลส่วนบุคคลให้ถูกต้อง"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ท่านมีสิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง หากข้อมูลส่วนบุคคลของท่านนั้นไม่ถูกต้อง ไม่เป็นปัจจุบัน ไม่ครบถ้วนสมบูรณ์ หรือก่อให้เกิดความเข้าใจผิด"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"7. สิทธิที่จะเพิกถอนความยินยอม"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "ในกรณีที่ หารือ.คอม อาศัยความยินยอมของท่านในการประมวลผลข้อมูลส่วนบุคคลของท่าน ท่านมีสิทธิในการเพิกถอนความยินยอมในการประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมกับ หารือ.คอม ได้ตลอดระยะเวลาที่ข้อมูลส่วนบุคคลของท่านอยู่ในความครอบครองของ หารือ.คอม"
                  }
                </SoftTypography>
                <SoftTypography variant="h6" mt={3} mb={1}>
                  {"8. สิทธิในการยื่นข้อร้องเรียน"}
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "หากท่านมีความกังวลหรือมีข้อสงสัยเกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของท่านโดย หารือ.คอม โปรดติดต่อ หารือ.คอม โดยใช้รายละเอียดการติดต่อด้านล่าง ในกรณีที่มีการฝ่าฝืนกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ท่านมีสิทธิยื่นข้อร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล"
                  }
                </SoftTypography>
                <SoftTypography variant="body2" color="text" mb={1}>
                  {
                    "หารือ.คอม จะใช้ความพยายามอย่างเต็มที่ตามความสามารถของระบบที่เกี่ยวข้องเพื่ออำนวยความสะดวกและดำเนินการตามคำร้องขอของท่านโดยไม่ชักช้า เว้นแต่จะปรากฏข้อเท็จจริงว่า การดำเนินการตามคำร้องขอนั้นก่อให้เกิดภาระแก่ หารือ.คอม เกินสมควร หรือเสี่ยงต่อการละเมิดการคุ้มครองข้อมูลส่วนบุคคลของผู้อื่น หรือเป็นการขัดต่อกฎหมาย หรือกรณีที่เป็นการพ้นวิสัยในทางปฏิบัติตามคำร้องขอ"
                  }
                </SoftTypography>
              </SoftBox>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"ความมั่นคงปลอดภัยในการเก็บรักษาข้อมูลส่วนบุคคล"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "หารือ.คอม ได้จัดทำและ/หรือเลือกใช้ระบบการจัดเก็บข้อมูลส่วนบุคคลให้มีกลไกและเทคนิคที่เหมาะสม และมีมาตรการรักษาความมั่นคงปลอดภัยตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล และกฎหมายที่เกี่ยวข้อง รวมทั้งจำกัดการเข้าถึงข้อมูลส่วนบุคคลของท่านจากพนักงาน ลูกจ้าง และตัวแทนของ หารือ.คอม เพื่อป้องกันไม่ให้ข้อมูลส่วนบุคคลของท่านถูกนำไปใช้ เปิดเผย ทำลาย หรือเข้าถึงโดยไม่ได้รับอนุญาต"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"การเชื่อมโยงไปยังเว็บไซต์ ผลิตภัณฑ์และบริการของบุคคลภายนอก"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "การให้บริการของ หารือ.คอม อาจมีลิงก์เชื่อมโยงไปยังเว็บไซต์ แอปพลิเคชัน ผลิตภัณฑ์ และบริการของบุคคลภายนอก ซึ่งบุคคลภายนอกเหล่านั้นอาจเก็บรวบรวมข้อมูลบางอย่างเกี่ยวกับการใช้บริการของท่าน คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ใช้เฉพาะสำหรับการประมวลผลข้อมูลส่วนบุคคลภายใต้วัตถุประสงค์ที่กำหนดโดย หารือ.คอม เท่านั้น หารือ.คอม ไม่สามารถรับผิดชอบในความปลอดภัยหรือความเป็นส่วนตัวของข้อมูลใด ๆ ของท่านที่ถูกเก็บรวบรวมโดยเว็บไซต์ แอปพลิเคชัน ผลิตภัณฑ์ หรือบริการของบุคคลภายนอกดังกล่าว แม้ว่าท่านจะกดลิงก์เชื่อมโยงที่ปรากฏบนการให้บริการของ หารือ.คอม ก็ตาม ทั้งนี้ ท่านควรใช้ความระมัดระวังและตรวจสอบคำประกาศเกี่ยวกับความเป็นส่วนตัว/นโยบายคุ้มครองข้อมูลส่วนบุคคลของเว็บไซต์ แอปพลิเคชัน ผลิตภัณฑ์ และบริการของบุคคลภายนอกเหล่านั้นด้วย"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"วิธีการติดต่อ"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "หากท่านมีคำถามใด ๆ เกี่ยวกับคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ หรือต้องการใช้สิทธิของท่านตามที่กำหนดไว้ในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ โปรดติดต่อ หารือ.คอม ผ่านทางเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคลของ หารือ.คอม โดยใช้ช่องทางดังต่อไปนี้"
                }
                <br />
                {"E-mail"}: admin@ha-rue.com
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"กฎหมายที่ใช้บังคับ"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ อยู่ภายใต้การบังคับและการตีความตามกฎหมายไทย และศาลไทยเป็นผู้มีอำนาจในการพิจารณาข้อพิพาทใด ๆ ที่อาจเกิดขึ้นหรือเกี่ยวข้องกับคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้"
                }
              </SoftTypography>
              <SoftTypography variant="h5" mt={6} mb={3}>
                {"การเปลี่ยนแปลงคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้"}
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "หารือ.คอม อาจทำการเปลี่ยนแปลงคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้เป็นครั้งคราว เพื่อให้สอดคล้องกับการเปลี่ยนแปลงใด ๆ ที่เกี่ยวกับการประมวลผลข้อมูลส่วนบุคคลของท่าน และเพื่อให้สอดคล้องกับการเปลี่ยนแปลงใด ๆ ในกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลหรือกฎหมายอื่นที่เกี่ยวข้อง หารือ.คอม จะแจ้งให้ท่านทราบถึงการแก้ไขเปลี่ยนแปลงที่สำคัญใด ๆ ด้วยช่องทางที่เหมาะสม อย่างไรก็ตาม หารือ.คอม แนะนำให้ท่านตรวจสอบทบทวนคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้เป็นครั้งคราว"
                }
              </SoftTypography>
              <SoftTypography variant="body2" color="text" mb={1}>
                {
                  "ให้คำประกาศเกี่ยวกับความเป็นส่วนตัวฉบับนี้มีผลใช้บังคับตั้งแต่วันที่ 18 กุมภาพันธ์ 2566"
                }
              </SoftTypography>
            </SoftBox>
          </Card>
        </Container>
      </SoftBox>
    </Fragment>
  );
};

export default PrivacyPolicy;
